import { useEffect, useState } from "react";
import { CheckSquare, Square, Paperclip, Info } from "lucide-react";
import { api } from "../../../lib/api";

export const StepChecklist = ({ profile, value, onChange, onItems }) => {
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get("/hr/required", { params: { employment_type: profile.employment_type, is_student: profile.is_student, is_foreigner: profile.is_foreigner, is_driver: profile.is_driver } })
      .then((r) => { const list = r.data.filter((i) => i.required && i.type !== "contract"); setItems(list); onItems?.(list); })
      .catch(() => { setItems([]); onItems?.([]); });
  }, [profile.employment_type, profile.is_student, profile.is_foreigner, profile.is_driver]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!items) return <div className="skeleton-shimmer h-40 rounded-xl" />;
  const groups = [...new Set(items.map((i) => i.group))];
  const done = items.filter((i) => value[i.type]?.done).length;
  const set = (t, patch) => onChange({ ...value, [t]: { ...(value[t] || {}), ...patch } });

  return (
    <div className="space-y-4" data-testid="onb-step-checklist">
      <div className="flex items-center justify-between">
        <p className="text-sm text-zinc-600">Odhacz, co pracownik przyniósł pierwszego dnia. Resztę teczka będzie przypominać.</p>
        <span data-testid="onb-checklist-progress" className="font-mono text-sm font-black whitespace-nowrap">{done}/{items.length}</span>
      </div>
      <div className="h-1.5 bg-zinc-100 rounded-full overflow-hidden"><div className="h-full bg-emerald-500 transition-[width]" style={{ width: `${items.length ? (done / items.length) * 100 : 0}%` }} /></div>
      {groups.map((g) => (
        <div key={g} className="space-y-2">
          <div className="text-[10px] font-black uppercase tracking-widest text-zinc-500">{g}</div>
          {items.filter((i) => i.group === g).map((i) => {
            const v = value[i.type] || {};
            return (
              <div key={i.type} data-testid={`onb-item-${i.type}`} className={`border ${v.done ? "border-emerald-300 bg-emerald-50/40" : "border-zinc-200 bg-white"}`}>
                <button type="button" onClick={() => set(i.type, { done: !v.done })} data-testid={`onb-check-${i.type}`} aria-pressed={!!v.done} className="w-full flex items-center gap-3 px-3 py-3 text-left">
                  {v.done ? <CheckSquare className="w-5 h-5 text-emerald-600 shrink-0" /> : <Square className="w-5 h-5 text-zinc-300 shrink-0" />}
                  <div className="min-w-0 flex-1">
                    <div className="text-sm font-bold">{i.label}</div>
                    <div className="text-[11px] text-zinc-500 flex items-center gap-1"><Info className="w-3 h-3 shrink-0" />{i.hint}</div>
                  </div>
                </button>
                {v.done && (
                  <div className="px-3 pb-3 grid grid-cols-1 sm:grid-cols-3 gap-2 items-end">
                    <label className="block"><span className="font-label text-[10px] block mb-1">Data wydania</span>
                      <input type="date" value={v.issued_at || ""} onChange={(e) => set(i.type, { issued_at: e.target.value })} data-testid={`onb-issued-${i.type}`} className="w-full h-9 px-2 border border-zinc-300 text-sm font-mono outline-none focus:border-zinc-900 bg-white" /></label>
                    {i.expiry && (
                      <label className="block"><span className="font-label text-[10px] block mb-1">Ważne do *</span>
                        <input type="date" value={v.valid_until || ""} onChange={(e) => set(i.type, { valid_until: e.target.value })} data-testid={`onb-until-${i.type}`} className={`w-full h-9 px-2 border text-sm font-mono outline-none focus:border-zinc-900 bg-white ${v.valid_until ? "border-zinc-300" : "border-amber-400"}`} /></label>
                    )}
                    <label className="inline-flex items-center gap-2 h-9 px-3 ring-1 ring-zinc-300 hover:ring-zinc-900 cursor-pointer text-xs font-bold truncate">
                      <Paperclip className="w-3.5 h-3.5 shrink-0" /><span className="truncate">{v.file ? v.file.name : "Skan (opcjonalnie)"}</span>
                      <input type="file" accept="application/pdf,image/jpeg,image/png,image/webp" className="hidden" data-testid={`onb-file-${i.type}`} onChange={(e) => set(i.type, { file: e.target.files?.[0] || null })} />
                    </label>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
};

export const checklistValid = (items, value) => Object.entries(value).every(([t, v]) => { const it = items?.find((i) => i.type === t); return !v.done || !it || !it.expiry || !!v.valid_until; });
